/* global $ */

import { Controller } from 'stimulus';
import hasHistorySupport from '../helpers/hasHistorySupport';
import debounce from '../helpers/debounce';

class Overview extends Controller {
  connect() {
    this.searchDebounced = debounce(this.filter.bind(this), 200);
    this.filterDebounced = debounce(this.filter.bind(this), 20);
  }

  onSearchChange() {
    this.searchDebounced();
  }

  onFilterChange() {
    this.filterDebounced();
  }

  filter() {
    const parameters = $(this.formTarget).serialize();

    if (hasHistorySupport()) {
      const url = `${parameters ? '?' : ''}${parameters}`;
      window.history.replaceState(null, null, url);
    }

    $.get(`${this.data.get('api')}?${parameters}`).then((data) => this.outputList(data));
  }

  outputList(res) {
    const $html = $(res);
    const $output = $html.find('.js-overview-output');

    if ($output.length) {
      $(this.element).find('.js-overview-output').html($output.html());
    }
  }
}

Overview.targets = [
  'form',
  'search',
  'filter',
  'output',
];

export default Overview;
